import { render, staticRenderFns } from "./List-Invoice-CDC.vue?vue&type=template&id=b57dddde&scoped=true"
import script from "./List-Invoice-CDC.vue?vue&type=script&lang=js"
export * from "./List-Invoice-CDC.vue?vue&type=script&lang=js"
import style0 from "./List-Invoice-CDC.vue?vue&type=style&index=0&id=b57dddde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57dddde",
  null
  
)

export default component.exports